<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="calls row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-2 full-width">Cancelled Calls</h2>
        <router-link :to="{ name: 'calls' }" class="d-inline-block mb-2">
          &laquo; Back to calls
        </router-link>

        <call-list-filters :external-cancellation="true"></call-list-filters>

        <section v-if="!loading">
          <section v-if="prison">
            <call-list :headers="headers"></call-list>
          </section>
          <section v-else>
            <p>There was a problem getting your call data, please refresh and try again</p>
          </section>
        </section>

        <b-spinner v-else variant="primary" label="Loading call"></b-spinner>
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import CallList from '@/views/calls/callLists/CallList.vue';
import CallListFilters from '@/views/calls/callLists/CallListFilters.vue';

export default {
  components: {
    CallList,
    CallListFilters,
  },
  props: {},
  data() {
    return {
      loading: true,
      headers: [
        // { label: `${this.$options.filters.term('prison')} Number`, key: 'prisoner_number' },
        { label: 'Visitor', key: 'visitorName' },
        { label: 'Resident', key: 'prisonerNameAndNumber' },
        { label: 'Relationship', key: 'relationship' },
        { label: 'Requested For', key: 'requestedFor1' },
        { label: 'Booked For', key: 'bookedFor' },
        { label: 'Reason', key: 'reason' },
        { label: 'Cancellation Reviewed', key: 'external_cancellation' },
      ],
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  mounted() {
    // Update default filters for requested calls
    this.updateFilter('status', 'Cancelled');
    this.updateFilter('sort', 'requested_booking_slot_1.end_date_time');
    this.setPrisonData();

    // Finished loading
    this.loading = false;
  },
  methods: {
    updateFilter(filterName, e) {
      this.$store.commit('callList/SET_FILTER_ITEM', { name: filterName, value: e });
    },
    async setPrisonData() {
      const Prison = await this.$store.dispatch('prison/getPrison');

      if (Prison && this.prison.enable_wings) {
        // Add wing field if enabled
        this.headers.splice(3, 0, { key: 'wing', label: 'Wing' });
      }
    },
  },
}
</script>
